import React, { useState, useContext, useEffect } from 'react';
import { getWidgetTranslates } from '../../../common/utils/utils';
import T, { t } from '../../../common/components/T';
import UserContext from '../../../common/utils/getContext';
import FormInput from '../../form/components/form-input/FormInput/FormInput';
import { LangContext } from '../../../common/decorators/Language';
import { generateCompStylers, getStylePropsFunc } from '../../../common/utils/styles';
import SingleButton from '../../form/form-control-buttons/SingleButton/SingleButton';

const SearchBlockDesctop = ({
    compStyles,
    inputGlobFilter,
    globalSearchFunc,
    textsData,
    setShowFilterForm,
    closeModal,
    pageSettings,
    translates
}) => {
    const getStyleProps = (...keys) => getStylePropsFunc(compStyles, ...keys);

    const [transl, setTranslates] = useState(translates);
    const { translation } = useContext(LangContext);
    const { lang } = useContext(UserContext);
    useEffect(() => {
        if (translates) {
            setTranslates(translates);
        } else {
            getWidgetTranslates(lang, 'gridFilter', translation, setTranslates);
        }
    }, [lang, translation, translates]);
    const { stylers, classes } = generateCompStylers(compStyles);

    return (
        <div {...getStyleProps('searthPortalTable')}>
            <div {...getStyleProps('searthTable')}>
                <FormInput
                    title={{
                        body: !!textsData?.title ? (
                            textsData?.title
                        ) : (
                            <T
                                customTranslates={transl}
                                customLoading={!transl}
                                group='gridFilter'
                                textName='searthTableInputTitle'
                                defaultStr='Введите данные'
                                page='widget'
                            />
                        )
                    }}
                    value={inputGlobFilter?.[0]}
                    compStyle={{
                        wrapper: {
                            ...stylers.searthTableInput,
                            className: classes.searthTableInput
                        },
                        inner: { className: classes.searthTableInputInner }
                    }}
                    handlers={{
                        onKeyPress: async () => {
                            await globalSearchFunc(inputGlobFilter?.[0]);
                            closeModal();
                        },
                        onChange: (val) => {
                            inputGlobFilter?.[1](val);
                        }
                    }}
                    search={{ type: 'onInput' }}
                    placeholder={
                        textsData.globalSearthPlaceholder ||
                        t('gridHeader-searchUser', 'Поиск пользователя', 'widget', transl, 'gridFilter')
                    }
                    buttons={
                        !pageSettings?.hideGlobalSearch
                            ? {
                                  global: {
                                      icon: 'sliders',
                                      handler: () => {
                                          setShowFilterForm((pre) => !pre);
                                      }
                                  }
                              }
                            : {}
                    }
                />
            </div>
            <SingleButton
                clickFunc={async () => {
                    await globalSearchFunc(inputGlobFilter?.[0]);
                    closeModal();
                }}
                customButton={{ singleButton: compStyles?.mobileFirstSearchBlockButton }}
                type={'ok'}
                buttonText={<T textName='apply' defaultStr='Применить' />}
            />
        </div>
    );
};
export default SearchBlockDesctop;
